<template>
<div v-html="agreementContent"></div>
</template>
<script>
export default {
  name: 'UserAgreement',
  data() {
    return {
      agreementContent: ''
    }
  },
  mounted() {
    this.getAgreementContent()
  },
  methods: {
    getAgreementContent() {
      // 调用接口获取用户协议内容
      this.$store
        .dispatch('api/getWebContentByCode', {
          code: 'TOUSERAGREEMENT',
          type: 'AGREEMENT',
        })
        .then((data) => {
          // console.log(data);
          this.agreementContent = data.content

        });
    }
  }
}
</script>
<style>
body{
  padding: 20px;
  background-color: #f5f5f5;
  font-family: '微软雅黑';
  font-size: 16px;
}
p {
  font-size: 16px;
  line-height: 1.5;
  color: #333;
}
strong{
  font-size: 16px;
  line-height: 1.5;
  color: #333;
}
</style>